import React from "react";

interface TextSectionProps {
  heading?: string;
  subtext?: string;
  className?: string;
}

export const TextSection: React.FC<TextSectionProps> = ({
  heading,
  subtext,
  className = "",
}) => {
  return (
    <div className={`text-center max-w-3xl flex-col flex px-5 gap-5 ${className}`}>
      <p className="text-white md:text-3xl text-2xl lg:text-5xl leading-[56px]">
        {heading}
      </p>
      <p className="md:text-lg text-base lg:text-xl leading-[28px] text-[#FFFFFF99]">
        {subtext}
      </p>
    </div>
  );
};
